import { Pipe, PipeTransform } from '@angular/core';

export interface HighlightPart {
  text: string;
  match: boolean;
}

@Pipe({
  name: 'highlightMatch',
  standalone: false,
})
export class HighlightMatchPipe implements PipeTransform {
  transform(value: string | null | undefined, term: string | null | undefined): HighlightPart[] {
    if (!value) {
      return [];
    }
    const needle = term?.trim().toLowerCase();
    if (!needle) {
      return [{ text: value, match: false }];
    }

    const haystack = value.toLowerCase();
    const parts: HighlightPart[] = [];
    let cursor = 0;
    let index = haystack.indexOf(needle);
    while (index !== -1) {
      if (index > cursor) {
        parts.push({ text: value.slice(cursor, index), match: false });
      }
      parts.push({ text: value.slice(index, index + needle.length), match: true });
      cursor = index + needle.length;
      index = haystack.indexOf(needle, cursor);
    }
    if (cursor < value.length) {
      parts.push({ text: value.slice(cursor), match: false });
    }
    return parts;
  }
}
